import axios from "../axios-auth";

export const saleService = {
  saveSale
};

function saveSale(sale) {
  return axios.post("auth/sale", sale);
}
